interface SuperFancyNumber {
    n: number;
}

export const get2ndNumber = (num: SuperFancyNumber[]) => {
    return num[1].n.toFixed(1);
}